import {ElementNode, $applyNodeReplacement, $isTextNode} from 'lexical';
import {normFamily, normSize, cssFamily} from '../constants';

/** One A4 sheet. Saved as <section class="page">. Acts as its own editing root. */
export class PageNode extends ElementNode {
  static getType() { return 'doc-page'; }
  static clone(node) { return new PageNode(node.__key); }
  static importJSON() { return $createPageNode(); }
  exportJSON() { return {...super.exportJSON(), type: 'doc-page', version: 1}; }

  createDOM() {
    const el = document.createElement('section');
    el.className = 'page';
    return el;
  }
  updateDOM() { return false; }
  exportDOM() {
    const el = document.createElement('section');
    el.className = 'page';
    return {element: el};
  }
  static importDOM() {
    return {
      section: (dom) =>
        dom.classList.contains('page')
          ? {conversion: () => ({node: $createPageNode()}), priority: 2}
          : null,
      span: (dom) => {
        const fam = normFamily(dom.style.fontFamily);
        const size = normSize(dom.style.fontSize);
        if (!fam && !size) return null;
        return {
          priority: 1,
          conversion: () => ({
            node: null,
            forChild: (child) => {
              if ($isTextNode(child)) {
                const parts = [child.getStyle()];
                if (fam) parts.push(`font-family: ${cssFamily(fam)}`);
                if (size) parts.push(`font-size: ${size}`);
                child.setStyle(parts.filter(Boolean).join('; '));
              }
              return child;
            },
          }),
        };
      },
    };
  }
  isShadowRoot() { return true; }
}

export const $createPageNode = () => $applyNodeReplacement(new PageNode());
export const $isPageNode = (n) => n instanceof PageNode;